var _dec, _dec2, _dec3, _dec4, _dec5, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import objectArrayTrait from "../Decorators/objectArrayTrait";
import primitiveTrait from "../Decorators/primitiveTrait";
import mixTraits from "../mixTraits";
import CkanResourceFormatTraits from "./CkanResourceFormatTraits";
import ReferenceTraits from "./ReferenceTraits";
let CkanSharedTraits = (_dec = primitiveTrait({
  type: "boolean",
  name: "Use resource name",
  description: "True to use the name of the resource for the name of the catalog item; false to use the name of the dataset."
}), _dec2 = primitiveTrait({
  type: "boolean",
  name: "Use combination name where multiple resources",
  description: "Use a combination of the name and the resource format and dataset where there are multiple resources for a single dataset."
}), _dec3 = primitiveTrait({
  type: "boolean",
  name: "Use combination of dataset and resource name where multiple resources",
  description: "Use a combination of the name and the resource and dataset name where there are multiple resources for a single dataset."
}), _dec4 = objectArrayTrait({
  name: "Supported Resource Formats",
  description: "The supported distribution formats and their mapping to Terria types. " + "These are listed in order of preference.",
  type: CkanResourceFormatTraits,
  idProperty: "id"
}), _dec5 = primitiveTrait({
  type: "boolean",
  name: "Use single resource",
  description: "Only use a single resource for each dataset. If multiple resources exist, the highest match from `supportedResourceFormats` will be used. If this is true, then `useDatasetNameAndFormatWhereMultipleResources` and `useCombinationNameWhereMultipleResources` will be ignored"
}), _class = class CkanSharedTraits extends mixTraits(ReferenceTraits) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "useResourceName", _descriptor, this);
    _initializerDefineProperty(this, "useDatasetNameAndFormatWhereMultipleResources", _descriptor2, this);
    _initializerDefineProperty(this, "useCombinationNameWhereMultipleResources", _descriptor3, this);
    _initializerDefineProperty(this, "supportedResourceFormats", _descriptor4, this);
    _initializerDefineProperty(this, "useSingleResource", _descriptor5, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "useResourceName", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "useDatasetNameAndFormatWhereMultipleResources", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "useCombinationNameWhereMultipleResources", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "supportedResourceFormats", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "useSingleResource", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _class);
export { CkanSharedTraits as default };